import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-300 rounded-full bg-gradient-to-r from-[#FF2D8A] to-[#9D00FF] hover:from-[#FF4DA0] hover:to-[#B333FF] shadow-[0_0_20px_rgba(255,45,138,0.5)] hover:shadow-[0_0_30px_rgba(255,45,138,0.8)] overflow-hidden group';
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-193">{children}</span>
      <div className="absolute inset-0 h-full w-full bg-white/20 scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300 ease-out" data-id="element-194"></div>
    </>;
  if (href) {
    return <motion.a href={href} className={`${baseStyles} ${className}`} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-195">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseStyles} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} {...props} data-id="element-196">
      {content}
    </motion.button>;
}